import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { getUserData } from '@/auth/utils'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useGrupoUsuarioList() {
  // Use toast
  const toast = useToast()

  const userData = getUserData()

  const refTabelaprecoTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: '#' },
    { key: 'descricao', sortable: true, label: 'Descrição' },
    { key: 'data_inicio_validade', sortable: true, label: 'Data Inicio Validade' },
    { key: 'data_termino_validade', sortable: true, label: 'Data Termino Validade' },
    { key: 'data_inclusao', sortable: true, label: 'Data Criação' },
    { key: 'total_produto', sortable: true, label: 'Total produtos' },
    { key: 'actions', label: 'Ações' },
  ]
  const perPage = ref(10)
  const totalTabelaPreco = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 15, 20, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const dataInicioValidadeFilter = ref(null)
  const dataTerminoValidadeFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refTabelaprecoTable.value ? refTabelaprecoTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTabelaPreco.value,
    }
  })

  const refetchData = () => {
    refTabelaprecoTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, dataInicioValidadeFilter, dataTerminoValidadeFilter], () => {
    refetchData()
  })

  const findAllTabelaPreco = (ctx, callback) => {
    store
      .dispatch('appTabelaPreco/findAllTabelaPreco', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        data_inicio_validade: dataInicioValidadeFilter.value,
        data_termino_validade: dataTerminoValidadeFilter.value,
        usuario_inclusao: userData.id,
      })
      .then(response => {
        const { tabela_precos, total } = response.data

        const filteredTabelaPrecos = tabela_precos.filter(
          item => item.usuario_inclusao.id === userData.id,
        )
        callback(filteredTabelaPrecos)
        totalTabelaPreco.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching tabela precos list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'Admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === null) return 'warning'
    if (status === 1) return 'success'
    if (status === 0) return 'danger'
    return 'primary'
  }

  return {
    findAllTabelaPreco,
    tableColumns,
    perPage,
    currentPage,
    totalTabelaPreco,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTabelaprecoTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    dataInicioValidadeFilter,
    dataTerminoValidadeFilter,
  }
}
